import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterPanel = ({ onFilterChange }) => {
  const [filters, setFilters] = useState({
    dateRange: 'month',
    propertyType: 'all',
    status: 'all'
  });
  const [isSaving, setIsSaving] = useState(false);

  const handleSavePreset = () => {
    setIsSaving(true);
    const presetName = prompt('أدخل اسم الإعداد المسبق:');
    if (presetName) {
      const savedPresets = JSON.parse(localStorage.getItem('reportFilterPresets') || '[]');
      savedPresets?.push({ name: presetName, filters, date: new Date() });
      localStorage.setItem('reportFilterPresets', JSON.stringify(savedPresets));
      alert('تم حفظ الإعداد المسبق بنجاح');
    }
    setIsSaving(false);
  };

  const dateRangeOptions = [
    { value: 'today', label: 'اليوم' },
    { value: 'yesterday', label: 'أمس' },
    { value: 'last_7_days', label: 'آخر ٧ أيام' },
    { value: 'last_30_days', label: 'آخر ٣٠ يوم' },
    { value: 'this_month', label: 'هذا الشهر' },
    { value: 'last_month', label: 'الشهر الماضي' },
    { value: 'this_quarter', label: 'هذا الربع' },
    { value: 'this_year', label: 'هذا العام' },
    { value: 'custom', label: 'نطاق مخصص' }
  ];

  const propertyTypeOptions = [
    { value: 'all', label: 'جميع الأنواع' },
    { value: 'apartment', label: 'شقة' },
    { value: 'villa', label: 'فيلا' },
    { value: 'office', label: 'مكتب' },
    { value: 'shop', label: 'محل تجاري' },
    { value: 'warehouse', label: 'مستودع' },
    { value: 'land', label: 'أرض' }
  ];

  const locationOptions = [
    { value: 'all', label: 'جميع المواقع' },
    { value: 'dubai', label: 'دبي' },
    { value: 'abu_dhabi', label: 'أبوظبي' },
    { value: 'sharjah', label: 'الشارقة' },
    { value: 'ajman', label: 'عجمان' },
    { value: 'ras_al_khaimah', label: 'رأس الخيمة' }
  ];

  const staffOptions = [
    { value: 'all', label: 'جميع الموظفين' },
    { value: 'staff_1', label: 'أحمد محمد' },
    { value: 'staff_2', label: 'فاطمة علي' },
    { value: 'staff_3', label: 'محمد حسن' },
    { value: 'staff_4', label: 'سارة خالد' }
  ];

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onFilterChange(filters);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-foreground">تصفية التقارير</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={handleSavePreset}
          disabled={isSaving}
          iconName="Save"
          iconSize={16}
        >
          حفظ الفلتر
        </Button>
      </div>
      <div className="space-y-4">
        <Select
          label="النطاق الزمني"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => handleFilterChange('dateRange', value)}
        />

        {filters?.dateRange === 'custom' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="من تاريخ"
              type="date"
              value={filters?.startDate}
              onChange={(e) => handleFilterChange('startDate', e?.target?.value)}
            />
            <Input
              label="إلى تاريخ"
              type="date"
              value={filters?.endDate}
              onChange={(e) => handleFilterChange('endDate', e?.target?.value)}
            />
          </div>
        )}

        <Select
          label="نوع العقار"
          options={propertyTypeOptions}
          value={filters?.propertyType}
          onChange={(value) => handleFilterChange('propertyType', value)}
        />

        <Select
          label="الموقع"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => handleFilterChange('location', value)}
        />

        <Select
          label="الموظف"
          options={staffOptions}
          value={filters?.staffMember}
          onChange={(value) => handleFilterChange('staffMember', value)}
        />

        <Button
          variant="default"
          fullWidth
          onClick={handleApply}
          iconName="Check"
          iconPosition="right"
        >
          تطبيق التصفية
        </Button>
      </div>
    </div>
  );
};

export default FilterPanel;